import { useEffect, useState } from 'react'
export const BankCardRecognizer = (card) => {
    //  bankInfo ={ title: 'شماره کارت ناقص است', icon: null };

    // پایگاه داده شناسه بانک‌های ایرانی
    const bankDatabase = {
        '207177': { title: 'بانک توسعه صادرات', icon: '/images/bankIcons/207177.png' },
        '502229': { title: 'بانک پاسارگاد', icon: '/images/bankIcons/502229.png' },
        '502806': { title: 'بانک شهر', icon: '/images/bankIcons/502806.png' },
        '502908': { title: 'بانک توسعه تعاون', icon: '/images/bankIcons/502908.png' },
        '502910': { title: 'بانک کارآفرین', icon: '/images/bankIcons/502910.png' },
        '502938': { title: 'بانک دی', icon: '/images/bankIcons/502938.png' },
        '504172': { title: 'بانک رسالت', icon: '/images/bankIcons/504172.png' },
        '505416': { title: 'بانک گردشگری', icon: '/images/bankIcons/505416.png' },
        '505785': { title: 'بانک ایران زمین', icon: '/images/bankIcons/505785.png' },
        '505801': { title: 'بانک کوثر', icon: '/images/bankIcons/505801.png' },
        '507677': { title: 'بانک انصار', icon: '/images/bankIcons/507677.png' },
        '589210': { title: 'بانک سپه', icon: '/images/bankIcons/589210.png' },
        '589463': { title: 'بانک رفاه کارگران', icon: '/images/bankIcons/589463.png' },
        '603769': { title: 'بانک صادرات', icon: '/images/bankIcons/603769.png' },
        '603770': { title: 'بانک کشاورزی', icon: '/images/bankIcons/603770.png' },
        '603799': { title: 'بانک ملی ایران', icon: '/images/bankIcons/603799.png' },
        '606373': { title: 'بانک قرض الحسنه مهر', icon: '/images/bankIcons/606373.png' },
        '610433': { title: 'بانک ملت', icon: '/images/bankIcons/610433.png' },
        '621986': { title: 'بانک سامان', icon: '/images/bankIcons/621986.png' },
        '622106': { title: 'بانک پارسیان', icon: '/images/bankIcons/622106.png' },
        '627353': { title: 'بانک تجارت', icon: '/images/bankIcons/627353.png' },
        '627381': { title: 'بانک انصار', icon: '/images/bankIcons/627381.png' },
        '627412': { title: 'بانک اقتصاد نوین', icon: '/images/bankIcons/627412.png' },
        '627488': { title: 'بانک کارآفرین', icon: '/images/bankIcons/627488.png' },
        '627648': { title: 'بانک توسعه صادرات', icon: '/images/bankIcons/627648.png' },
        '627760': { title: 'پست بانک ایران', icon: '/images/bankIcons/627760.png' },
        '627884': { title: 'بانک پارسیان', icon: '/images/bankIcons/627884.png' },
        '627961': { title: 'بانک صنعت و معدن', icon: '/images/bankIcons/627961.png' },
        '628023': { title: 'بانک مسکن', icon: '/images/bankIcons/628023.png' },
        '636214': { title: 'بانک آینده', icon: '/images/bankIcons/636214.png' },
        '636795': { title: 'بانک مرکزی', icon: '/images/bankIcons/636795.png' },
        '636949': { title: 'بانک حکمت ایرانیان', icon: '/images/bankIcons/636949.png' },
        '639194': { title: 'بانک پارسیان', icon: '/images/bankIcons/639194.png' },
        '639217': { title: 'بانک کشاورزی', icon: '/images/bankIcons/639217.png' },
        '639346': { title: 'بانک سینا', icon: '/images/bankIcons/639346.png' },
        '639347': { title: 'بانک پاسارگاد', icon: '/images/bankIcons/639347.png' },
        '639370': { title: 'بانک مهر اقتصاد', icon: '/images/bankIcons/639370.png' },
        '639607': { title: 'بانک سرمایه', icon: '/images/bankIcons/639607.png' },
        '991975': { title: 'بانک ملت', icon: '/images/bankIcons/991975.png' }
    };

    // استخراج 6 رقم اول (شناسه بانک)
    const bankId = card.slice(0, 6);

    // جستجو در پایگاه داده بانک‌ها
    const bankInfo = (card ?? "").length < 6 ? { title: 'بانک صادرکننده شناسایی نشد', icon: '/images/bankIcons/000000.png' } :
        bankDatabase[bankId] || { title: 'بانک صادرکننده شناسایی نشد', icon: '/images/bankIcons/000000.png' };

    return { bankInfo }
}